var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 4,
  width: 24,
  height: 17,
  rx: 2,
  fill: "#0079BE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.18 17.624H13.0126C15.8731 17.624 18.1526 15.3545 18.242 12.5511V12.5066C18.1973 9.65873 15.8731 7.3448 13.0126 7.3893H10.9565C8.23009 7.4783 6.08469 9.79222 6.17408 12.5511C6.17408 15.31 8.40888 17.5795 11.18 17.624ZM7.06791 12.5066C7.06791 10.1927 8.98984 8.27925 11.314 8.27925C13.6382 8.27925 15.5601 10.1927 15.5601 12.5066C15.5601 14.8205 13.6382 16.734 11.314 16.734C8.98984 16.734 7.06791 14.8205 7.06791 12.5066ZM11.9845 15.3545V9.70321C13.5489 10.1037 14.5322 11.6611 14.1299 13.2186C13.8618 14.2866 13.0572 15.0875 11.9845 15.3545ZM8.54306 11.7946C8.1408 13.3521 9.07942 14.954 10.6438 15.3545V9.70321C9.61577 9.9702 8.81124 10.7712 8.54306 11.7946Z",
  fill: "white"
});

function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.12cac306a5289420980178cc6932c788.svg";
export { ForwardRef as ReactComponent };